module.exports = {
  home: '/',
  about: '/about',
  works: '/works',
  erbConnect: '/works/erb-connect',
  mavenPro: '/works/maven-pro',
  fourOhFour: '/404',
  writing: '/writing',
  posts: {
    empathy: '/writing/empathy',
  },
}



// WEBPACK FOOTER //
// ./src/data/routes.js